import React from 'react';

export default function KYCAMLPolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          KYC &amp; AML Compliance Policy
        </h1>

        <p className="text-gray-700 mb-8">
          Million2Trillion (M2T) operates under strict Know Your Customer (KYC) and Anti-Money Laundering (AML) compliance standards to protect all verified users across the global financial ecosystem.
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          KYC Verification Process
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All monetized members, advisors, service providers, and financial contributors must complete full identity verification.</li>
          <li>KYC documentation includes: Government-issued ID, Address Proof, Selfie Verification, Tax Declarations, and Corporate Registration (if applicable).</li>
          <li>For high-risk jurisdictions or regulated roles, enhanced due diligence (EDD) may apply, including additional legal certification requirements.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Ongoing Verification Updates
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All KYC records are reviewed periodically to ensure validity of submitted information and regulatory compliance status.</li>
          <li>Any substantial changes to user legal status, business structure, or residency require prompt KYC updates.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Anti-Money Laundering (AML) Protection
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All payment flows are continuously monitored for suspicious activities, large-volume fund movements, unusual payout requests, or potential blacklisted accounts.</li>
          <li>Suspicious fund flows may result in transaction holds, compliance reviews, or law enforcement reporting based on international AML treaties.</li>
          <li>M2T strictly prohibits usage of the platform for any illicit financial activities including but not limited to: sanctions evasion, terrorist financing, tax evasion, or criminal enterprise funding.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Data Security &amp; Confidentiality
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>KYC documents are securely stored in encrypted systems fully compliant with GDPR, CCPA, and global privacy laws.</li>
          <li>Private KYC data is never sold, shared, or commercialized outside of lawful compliance reporting duties.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          KYC protects verified trust. AML protects global financial integrity. Together, they form the foundation of M2T’s secure verified marketplace.
        </p>
      </div>
    </div>
  );
}
